import { questionLibraryStore } from "../stores/question-library.store";

export const useQuestionLibraryStore = () => questionLibraryStore;
